import {Suspense} from 'react';
import AppRouter from './Routes';
import {device} from '@guestapp/ui/src/utils/device';
import AppProviders from 'context';
import {useScreenResize} from 'hooks';
import ScrollToTop from 'utils/scrollToTop';
import PageSideBar from 'components/PageSideBar';
import {PageWrapper, SuspenseLoader} from './styled/common';

function App() {
  const {isMatch: isMobile} = useScreenResize(device.tabletSubHeader);
  const [, , , token] = window.location.href.split('/');
  const isWrongPage = !Boolean(token);
  return (
    <AppProviders>
      <ScrollToTop />

      <Suspense fallback={<SuspenseLoader width={80} visible />}>
        <PageWrapper invalidLink={isWrongPage}>
          {!isMobile && !isWrongPage && <PageSideBar />}
          <AppRouter />
        </PageWrapper>
      </Suspense>
    </AppProviders>
  );
}

export default App;
